import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { accentForCurrency } from 'utils/currency//currency-utils';
import { displayPriceSubUnit, priceFromInput, toSubUnit } from '../../../utils';
import EditorRow from '../EditorRow';

const ClearNumberArrows = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

const StyledAdornment = styled(InputAdornment)`
  && {
    & > p {
      font-family: Basier Circle;
      font-size: 15px;
      color: #797979;
      padding-bottom: 2px;
    }
  }
`;

const ErrorMessage = styled.p`
  font-family: Basier Circle;
  font-size: 12px;
  color: #d32f2f;
  margin: 4px 0 0 0;
  line-height: 1;
`;

const StyledInput = styled(Input)`
  ${props =>
    props.hasError &&
    `
    & input {
      border-color: #d32f2f !important;
      color: #d32f2f;
    }
  `}
`;

const CostPriceField = props => {
  const {
    id,
    className,
    value,
    price,
    onChange,
    disabled,
    hideLabel,
    labelAdornment,
    width,
    currency,
  } = props;

  const [rawPrice, setRawPrice] = useState(displayPriceSubUnit(value));

  const hasError =
    value !== undefined &&
    value !== null &&
    price !== undefined &&
    price !== null &&
    value >= price;
  const errorMessage = hasError ? 'Must be less than selling price' : '';

  let rawOnChange = e => {
    const price = priceFromInput(e.target.value);

    setRawPrice(price);
    onChange({ ...e, target: { ...e.target, value: toSubUnit(price) } });
  };

  return (
    <EditorRow className={className} width={width || 114}>
      <label htmlFor={id} style={{ display: hideLabel ? 'none' : '' }}>
        {labelAdornment}Cost (optional)
      </label>
      <ClearNumberArrows>
        <StyledInput
          hasError={hasError}
          id={id}
          onChange={rawOnChange}
          value={rawPrice}
          placeholder="Cost"
          disabled={disabled}
          size="small"
          type="number"
          startAdornment={
            <StyledAdornment position="start">
              {accentForCurrency(currency)}
            </StyledAdornment>
          }
          inputProps={{ min: '0', step: '0.01' }}
          fullWidth={true}
          style={{ width: '70px' }}
        />
      </ClearNumberArrows>
      {hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </EditorRow>
  );
};

CostPriceField.propTypes = {
  value: PropTypes.number,
  price: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
};

CostPriceField.defaultProps = {
  disabled: false,
  value: undefined,
  price: undefined,
};

const mapStateToProps = state => {
  return {
    currency: state.venue.currency,
  };
};

export default connect(mapStateToProps)(CostPriceField);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/CostPriceField/index.jsx